module.exports = __webpack_public_path__ + "static/media/level1.2bdf261b.svg";